// d88a0b5e33a0fc9e3ecff4452e7a717a9acf33cd|kind=parser-js|name=CtaRequest|schemaHash=a165ca8ceca0c823c458a0e4ead46f8561b1d96e

import { setDefinedValue } from '@myre/common-primitives';

export function parseCtaRequestFromJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'action', _data.action);
  setDefinedValue(result, 'payload', _data.payload);

  return result;
}

export function parseCtaRequestToJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'action', _data.action);
  setDefinedValue(result, 'payload', _data.payload);

  return result;
}
